module.exports = __webpack_public_path__ + "static/glorious_2-3582b064fc5b2220b0a807fc0f18ee96.jpg";